export default [
  {
    date: "2022-07-24",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACdXUaTuktPH_0WCL3Dzayca/24%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAAshM_rTwkgmb5-XfmlemZNa/24%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAAR_daQlShpg-U8ntyVWBVka/24%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADdkqgXROmzoakkR2f5-7owa/24%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
  {
    date: "2022-07-25",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACNtVIRju8U0wVIB_wNI7H7a/25%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADs2SyiX36PbqytQ-R1Mngua/25%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAAl3MKSncxjx8bxQQPC2AsUa/25%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADz2V9rt_KphANOn_CIj809a/25%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
  {
    date: "2022-07-26",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACTy9VaoDpmomwzwGej1oDxa/26%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAAL2GmrtSuKNK2MQWO3jbhra/26%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAD7mopohD4SFbWp0aRWtTxIa/26%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAAgwtl5sfKjB7KFb_w1tHvZa/26%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
  {
    date: "2022-07-27",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADS2SJ2DsDVTHN3ct_52zfRa/27%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AABDuWsptwgsw7X4ZBaX65eka/27%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAA5_LWNPVeSd6nZEByOLUMEa/27%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADH9pFxxe4kqztPQc49QclXa/27%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
  {
    date: "2022-07-28",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAARasnPM2TtBVQiTCH2FbzUa/28%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACQY5ARsxr0bc_5H2_u915Ea/28%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAANWk3UdixpUtpgWD-WdQKva/28%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADUsTr6Fv5Lnwb9WCrQXPCma/28%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
  {
    date: "2022-07-29",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAB4nHIxu-KvduWsOTCzYduaa/29%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADVC6gd20__X3nhO5QOQBeEa/29%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADs6AUcxl9E2ZeTqiJ2n1Hca/29%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACTgnhUNWUSmNkJg4M6O4YNa/29%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
  {
    date: "2022-07-30",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACVwMAweW27Cs_Wen_Ja3Jya/30%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACiNa6MPY-aqNrTPQFxeA45a/30%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AABfcIfdbhLNMYrS23azrjfEa/30%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACQPiWaXPQWRfiJlMk0s4Sqa/30%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
  {
    date: "2022-07-31",
    links: {
      day: "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACiUT0H-g0ntE0BcjWFGCYua/31%20de%20Julio?dl=0&lst=",
      agenda:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AACdvYg2GwHq0owAd8m36VFda/31%20de%20Julio/Agenda?dl=0&lst=",
      materials:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AAAPJ_bz65LUxHTGBcypoLbpa/31%20de%20Julio/Materiales?dl=0&lst=",
      pressNotes:
        "https://www.dropbox.com/sh/lio7iorq4dl3noi/AADnybUzSmRkjYGM0GtUDvZda/31%20de%20Julio/Nota%20de%20prensa?dl=0&lst=",
    },
  },
];
